import PropTypes from "prop-types";
import { Link, useLocation, useParams } from "react-router-dom";
import clsx from "clsx";
import CollectionGridShop from "../Shop/CollectionGridShop";
import React, { useEffect, useState } from "react";
import { usePartner } from "../../helpers/BrandPageAPI";

const NavMenu = React.memo(({ menuWhiteClass, sidebarMenu }) => {
  const location = useLocation();
  const { partnerData } = usePartner();
  const navColor = partnerData?.StoreColor || "#d4af37";
  const customerStore = useParams();
  const customerLink = customerStore?.UserCode;

  const [hoverState, setHoverState] = useState({
    collection: false,
    category: false,
  });

  const handleMouseEnter = (menu) => {
    setHoverState((prev) => ({ ...prev, [menu]: true }));
  };

  const handleMouseLeave = (menu) => {
    setHoverState((prev) => ({ ...prev, [menu]: false }));
  };

  useEffect(() => {
    setHoverState({ jewellery: false, collection: false });
  }, [location]);

  return (
    <div
      className={clsx(
        sidebarMenu
          ? "sidebar-menu"
          : `main-menu ${menuWhiteClass ? menuWhiteClass : ""}`
      )}
      style={{ "--nav-hover-color": navColor }}
    >
      <nav>
        <ul>
          {/* <li>
            <Link to={`/${customerLink}/AboutUs`}>About</Link>
          </li> */}
          <li
            className={hoverState.category ? "hovered" : ""}
            onMouseEnter={() => handleMouseEnter("category")}
            onMouseLeave={() => handleMouseLeave("category")}
          >
            <Link to="#" onClick={(e) => e.preventDefault()}>
              Jewelry
            </Link>
            {
              Array.isArray(partnerData?.Categories) && partnerData.Categories.length > 0 && (
                <div className="menu_dropdown collection">
                  <div className="menu_con">
                    {partnerData.Categories.map((category, index) => (
                      <Link to={`/${customerLink}/category/${category.GatiCategoryId}`} key={index} style={{ color: navColor, }}>
                        {category.DesgGroupName}
                      </Link>
                    ))}
                  </div>
                  <CollectionGridShop />
                </div>
              )
            }
          </li>
          <li
            className={hoverState.collection ? "hovered" : ""}
            onMouseEnter={() => handleMouseEnter("collection")}
            onMouseLeave={() => handleMouseLeave("collection")}
          >
            <Link to="#" onClick={(e) => e.preventDefault()}>
              Collection
            </Link>

            {Array.isArray(partnerData?.Collection) && partnerData.Collection.length > 0 && (
              <div className="menu_dropdown collection">
                <div className="menu_con">
                  {partnerData.Collection.map((collection, index) => (
                    <Link to={`/${customerLink}/collection/${collection.GatiCategoryId}`} key={index} style={{ color: navColor, }}>
                      {collection.DesgGroupName}
                    </Link>
                  ))}
                </div>
                <CollectionGridShop />
              </div>
            )}
          </li>
          <li>
            <Link to={`/${customerLink}/connectUs`}>Connect Us</Link>
          </li>
        </ul>
      </nav>
    </div>
  );
});

NavMenu.propTypes = {
  menuWhiteClass: PropTypes.string,
  sidebarMenu: PropTypes.bool,
};

export default NavMenu;
